import React from 'react';
import CEOHeadshot from '../../assets/CEO-headshot.png';
import CGOHeadshot from '../../assets/CGO-headshot.png';
import useInView from '../../hooks/useInView';
import './FoundersHouse.css';

const FoundersHouse = () => {
  const { ref, inView } = useInView({ threshold: 0.4 });

  return (
    <div className={`founders-house${inView ? ' founders-house--visible' : ''}`}>
      <svg
        className="founders-house__svg"
        viewBox="0 0 100 110"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <polyline
          className="founders-house__path"
          points="0,110 0,42 50,8 100,42 100,110"
          fill="none"
        />
      </svg>
      <div className="founders-house__bulb" aria-hidden="true">💡</div>
      <div ref={ref} className="founders-house__photos">
        <img src={CEOHeadshot} alt="CEO" className="founders-house__photo" />
        <img src={CGOHeadshot} alt="CGO" className="founders-house__photo" />
      </div>
    </div>
  );
};

export default FoundersHouse;
